import { Injectable, Inject } from '@angular/core';
import { Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Servizio, StaticUrls, ServizioAcquistato, PacchettoServizio, ServizioSearch, Immobile } from '../models';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { MatDialogRef } from '@angular/material';
import { DialogServizioUploadFattura } from '../components/area-utente/servizi/dialogs/dialog-servizio-upload-fattura/dialog-servizio-upload-fattura.component';
import { MyCookieService } from './my-cookie.service';
import { AuthHttp, tokenNotExpired } from 'angular2-jwt';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable()
export class ServizioImmobileService {

	private servizio: Servizio;
	private servizi: Servizio[];
	private serviziImmobile: ServizioAcquistato[];
	private servizioAcquistato: ServizioAcquistato;
	private idImmobile: number;
	private headers = new Headers({ 'Content-Type': 'application/json' });
	private options = new RequestOptions({ headers: this.headers });

	constructor(private http: AuthHttp, 
		private router: Router, 
		@Inject(MyCookieService) private myCookieService: MyCookieService) 
	{ }

	getByDD(dominio: string, descrizione: string): Observable<Servizio> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._getServizioByDD(dominio, descrizione), this.options)
				.map(this.extractDataObj)
				.catch(this.handleError);
		}
	}
	// restituisce i servizi da acquistare per quelli che hanno un costo variabile
	getByDomDescWithCostoVar(dominio: string, descrizione: string, immobile: Immobile): Observable<Servizio> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.post(StaticUrls._getServizioByDD(dominio, descrizione), JSON.stringify(immobile),this.options)
				.map(this.extractDataObj)
				.catch(this.handleError);
		}
	}
	getCostoServizio(idTipologia: number, codice: string): Observable<Servizio> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._getCostoServizio(idTipologia, codice), this.options)
				.map(this.extractDataObj)
				.catch(this.handleError);
		}
	}

	servizioPubblicazione(idImmobile: number): Observable<any> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.post(StaticUrls._servizioPubblicazione(idImmobile), this.options);
		}
	}

	searchScadenziario(servizio: ServizioSearch): Observable<Array<ServizioAcquistato>> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.post(StaticUrls._servizioScadenziario, servizio, this.options)
				.map(this.extractDataAcquistato)
				.catch(this.handleError);
		}
	}

	numServiziErogatiInScadenza(): Observable<number> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._servizioNumErogatiInScadenza, this.options)
				.map(result => {
					return result.json();
				})
				.catch(this.handleError);
		}
	}
	
	checkDisponibilita(comune: string, cap: string, tipoPosizione: string): Observable<boolean> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._checkDispServizio(comune, cap, tipoPosizione), this.options)
				.map(result => {
					if (result.status == 200) {
						return true;
					} else {
						return false;
					}
				})
				.catch(this.handleError);
		}
	}

	numServiziNonErogati(): Observable<number> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._servizioNonErogati, this.options)
				.map(result => {
					return result.json();
				})
				.catch(this.handleError);
		}
	}

	numServiziErogatiNoRating(): Observable<number> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._servizioImmobileErogatiNoRating, this.options)
				.map(result => {
					return result.json();
				})
				.catch(this.handleError);
		}
	}
	
	getByDominio(dominio: string): Observable<Servizio[]> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._getServizioByDominio(dominio), this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	getByDominioWithCostoVar(dominio: string, immobile: Immobile): Observable<Servizio[]> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.post(StaticUrls._getServizioByDominio(dominio), JSON.stringify(immobile),this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	getById(id: number): Observable<ServizioAcquistato> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._getServizioById(id), this.options)
				.map(this.extractDataObjAcquistato)
				.catch(this.handleError);
		}
	}

	getByParentDD(dominio: string, descrizione: string): Observable<Servizio[]> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._getServizioByParentDD(dominio, descrizione), this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	getByParentDDWithCostoVar(dominio: string, descrizione: string, immobile: Immobile): Observable<Servizio[]> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.post(StaticUrls._getServizioByParentDD(dominio, descrizione), JSON.stringify(immobile),this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	post(idImmobile: number, servizi: Servizio[], serviziVisura: Servizio[], serviziCertificazione: Servizio[],
				serviziCopia: Servizio[], serviziPlanimetria: Servizio[]): Observable<Response> {
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			this.serviziImmobile = [];
			this.idImmobile = idImmobile;
			if(servizi != undefined){
				servizi.forEach(this.servizioForEach.bind(this));
			}
			if(serviziVisura != undefined){
				serviziVisura.forEach(this.servizioForEach.bind(this));
			}
			if(serviziCertificazione != undefined){
				serviziCertificazione.forEach(this.servizioForEach.bind(this));
			}
			if(serviziCopia != undefined){
				serviziCopia.forEach(this.servizioForEach.bind(this));
			}
			if(serviziPlanimetria != undefined){
				serviziPlanimetria.forEach(this.servizioForEach.bind(this));
			}
			  
			return this.http.post(StaticUrls._servizioVenditore, this.serviziImmobile, this.options)
				.map((response: Response) => {
					//if(response.status === 200){
						return response;
					//}
				} )
				.catch(this.handleError);
		}
	}

	servizioForEach(value: Servizio, index: number, array: Servizio[]) {
		if(value != undefined){
			this.serviziImmobile.push(new ServizioAcquistato(this.idImmobile, value.tipologiaServizio.id, value.costoScontato, null, 
					value.sottoCategorie != undefined && value.sottoCategorie.length == 1 ? value.sottoCategorie[0].tipologiaServizio.id : null
				));
		}
	}

	search(servizio: ServizioSearch): Observable<ServizioAcquistato[]>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.post(StaticUrls._servizioSearch, JSON.stringify(servizio), this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	delete(id: number): Observable<any>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.delete(StaticUrls._servizio + '/' + id, this.options);
		}
	}

	searchCliente(servizio: ServizioSearch): Observable<Array<PacchettoServizio>>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.post(StaticUrls._servizioSearchCliente, JSON.stringify(servizio), this.options)
				.map(this.extractData)
				.catch(this.handleError);
		}
	}

	putRating(id: number, rating: number): Observable<Response>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			let servizio = new ServizioAcquistato();
			servizio.rating = rating;
			servizio.id = id;
			return this.http.put(StaticUrls._servizioUpdateRating, JSON.stringify(servizio), this.options)
				.map( (response: Response) => { return response; })
				.catch(this.handleError);
		}
	}

	putRatingCommento(id: number, commento: string): Observable<Response>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			let servizio = new ServizioAcquistato();
			servizio.ratingCommento = commento;
			servizio.id = id;
			return this.http.put(StaticUrls._servizioUpdateRatingComm, JSON.stringify(servizio), this.options)
				.map( (response: Response) => { return response; })
				.catch(this.handleError);
		}
	}
	
	setErogato(idServizio: number): Observable<ServizioAcquistato>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.put(StaticUrls._servizioSetErogato, idServizio, this.options)
				.map( (response: Response) => {
					if(response.status === 200){
						return response.json();
					}
				})
				.catch(this.handleError);
		}
	}

	setCollaboratorePagato(idsServizio: Array<number>): Observable<boolean>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.put(StaticUrls._servizioSetCollaboratorePagato, idsServizio, this.options)
				.map( (response: Response) => {
					if(response.status === 200){
						return true;
					}
				})
				.catch(this.handleError);
		}
	}

	rigetta(servizio: ServizioAcquistato): Observable<boolean>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.put(StaticUrls._servizioImmobileRigetta, JSON.stringify(servizio), this.options)
				.map( (response: Response) => {
					if(response.status === 200){ return true; }
				}).catch(this.handleError);
		}
	}

	uploadFattura(idServizio: number, uploader: FileUploader, dialogRef: MatDialogRef<DialogServizioUploadFattura>) {
		
		let uploaderOptions: FileUploaderOptions = uploader.options;
		uploaderOptions.url = StaticUrls._servizioUploadFattura(idServizio);
		uploaderOptions.authTokenHeader = environment.headerName;
		if(this.myCookieService.token){
			uploaderOptions.authToken = localStorage.getItem(environment.tokenName);			
		}
		uploader.setOptions(uploaderOptions);
		uploader.uploadAll();
		
	}

	// Contiene Anche l'immobile collegato
	getNonPagati(): Observable<ServizioAcquistato[]>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._servizioGetNonPagati, this.options)
				.map( (response: Response) => {
					if(response.status === 200){
						return response.json();
					}
				} )
				.catch(this.handleError);
		}
	}

	countNonPagati(): Observable<number>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._servizioCountNonPagati, this.options)
				.map( (response: Response) => {
					if(response.status === 200){
						return response.json();
					}
				} )
				.catch(this.handleError);
		}
	}

	// Non contiene l'immobile
	getByIdImmobileShort(idImmobile: number): Observable<ServizioAcquistato[]>{
		if(this.myCookieService.token){
			this.ifTokenNotExpired();
			return this.http.get(StaticUrls._servizio_get_by_immobile_short(idImmobile), this.options)
				.map( (response: Response) => {
					if(response.status === 200){
						return response.json();
					}
				} )
				.catch(this.handleError);
		}
	}

	private handleResponse(response: Response) {
		if (response.status === 200) {
			return { id: response.json(), error: false };
		}

		return { id: null, error: true };
	}

	private extractDataObj(res: Response) {
		this.servizio = res.json();
		return this.servizio;
	}

	private extractDataObjAcquistato(res: Response) {
		this.servizioAcquistato = res.json();
		return this.servizioAcquistato;
	}

	private extractDataAcquistato(res: Response) {
		this.serviziImmobile = res.json();
		return this.serviziImmobile;
	}

	private extractData(res: Response) {
		this.servizi = res.json();
		return this.servizi;
	}
/* TODO remove
	private extractDataJson(res: Response) {
		return res.json();
	}
*/
	private handleError(error: Response | any) {
		let errMsg: string;

		if (error instanceof Response) {
			const body = error.json() || '';
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
		} else {
			errMsg = error.message ? error.message : error.toString();
		}

		return Observable.throw(errMsg);
	}

	private ifTokenNotExpired() {
		if(this.myCookieService.token){
			if (!tokenNotExpired(environment.tokenName)) {
				this.router.navigate(['login']);
				return false;
			} else {
				return true;
			}
		} else {
			return false;
		}
	}
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/services/servizio-immobile.service.ts